import { type Ref } from 'vue'
import { useHandleEvent } from './useHandleEvent'
import { useWebComponentNode } from './useWebComponentNode'

export function useHandleClickOutside(
  refElement: Ref<HTMLElement | null>,
  onClickOutside: (event: MouseEvent) => void,
) {
  let pause = false

  // Prise en charge du fonctionnement en tant que webComponent
  const shadowRoot = useWebComponentNode().shadowRoot

  useHandleEvent(shadowRoot ?? document, 'mousedown', (event: MouseEvent) => {
    if (pause) return
    if (refElement.value && !refElement.value.contains(event.target as Node)) {
      onClickOutside(event)
    }
    if (shadowRoot) event.stopPropagation()
  })

  if (shadowRoot) {
    useHandleEvent(document, 'mousedown', (event: MouseEvent) => {
      if (pause) return
      onClickOutside(event)
    })
  }

  async function pauseClickOutside(callback: () => void | Promise<void>) {
    try {
      pause = true
      await callback()
    } finally {
      pause = false
    }
  }
  return {
    pauseClickOutside,
  }
}
